import { logEvent } from 'firebase/analytics';
import { analytics } from '../firebase-config.js';

// FAQ DOM Elements - Questions
const q1 = document.querySelector('.q-1');
const q2 = document.querySelector('.q-2');
const q2b = document.querySelector('.q-2b');
const q3 = document.querySelector('.q-3');
const q4 = document.querySelector('.q-4');
const q5 = document.querySelector('.q-5');
const q6 = document.querySelector('.q-6');
const q7 = document.querySelector('.q-7');

// FAQ DOM Elements - Answers
const a1 = document.querySelector('.a-1');
const a2 = document.querySelector('.a-2');
const a2b = document.querySelector('.a-2b');
const a3 = document.querySelector('.a-3');
const a4 = document.querySelector('.a-4');
const a5 = document.querySelector('.a-5');
const a6 = document.querySelector('.a-6');
const a7 = document.querySelector('.a-7');

// FAQ DOM Elements - Answer Text
const a1Text = document.querySelector('.a-1-text');
const a2Text = document.querySelector('.a-2-text');
const a2bText = document.querySelector('.a-2b-text');
const a3Text = document.querySelector('.a-3-text');
const a4Text = document.querySelector('.a-4-text');
const a5Text = document.querySelector('.a-5-text');
const a6Text = document.querySelector('.a-6-text');
const a7Text = document.querySelector('.a-7-text');

// FAQ DOM Elements - Expanders
const exp1 = document.querySelector('.exp-1');
const exp2 = document.querySelector('.exp-2');
const exp2b = document.querySelector('.exp-2b');
const exp3 = document.querySelector('.exp-3');
const exp4 = document.querySelector('.exp-4');
const exp5 = document.querySelector('.exp-5');
const exp6 = document.querySelector('.exp-6');
const exp7 = document.querySelector('.exp-7');

// Question / Answer 1
q1.addEventListener('click', function () {
  //adjust the height of the answer
  if (a1.offsetHeight == 0) {
    a1.style.height = a1Text.offsetHeight + 20 + "px";
    logEvent(analytics, 'faq_why_subscribe_opened');
  }
  else {
    a1.style.height = 0;
    logEvent(analytics, 'faq_why_subscribe_closed');
  }

  //toggle the expander UI
  exp1.classList.toggle('is-active');

  //collapse any other expanded questions
  if (a2.offsetHeight > 0) { a2.style.height = 0; exp2.classList.toggle('is-active'); }
  if (a2b.offsetHeight > 0) { a2b.style.height = 0; exp2b.classList.toggle('is-active'); }
  if (a3.offsetHeight > 0) { a3.style.height = 0; exp3.classList.toggle('is-active'); }
  if (a4.offsetHeight > 0) { a4.style.height = 0; exp4.classList.toggle('is-active'); }
  if (a5.offsetHeight > 0) { a5.style.height = 0; exp5.classList.toggle('is-active'); }
  if (a6.offsetHeight > 0) { a6.style.height = 0; exp6.classList.toggle('is-active'); }
  if (a7.offsetHeight > 0) { a7.style.height = 0; exp7.classList.toggle('is-active'); }
});

// Question / Answer 2
q2.addEventListener('click', function () {
  //adjust the height of the answer
  if (a2.offsetHeight == 0) {
    a2.style.height = a2Text.offsetHeight + 20 + "px";
    logEvent(analytics, 'faq_how_process_works_opened');
  }
  else {
    a2.style.height = 0;
    logEvent(analytics, 'faq_how_process_works_closed');
  }

  //toggle the expander UI
  exp2.classList.toggle('is-active');

  //collapse any other expanded questions
  if (a1.offsetHeight > 0) { a1.style.height = 0; exp1.classList.toggle('is-active'); }
  if (a2b.offsetHeight > 0) { a2b.style.height = 0; exp2b.classList.toggle('is-active'); }
  if (a3.offsetHeight > 0) { a3.style.height = 0; exp3.classList.toggle('is-active'); }
  if (a4.offsetHeight > 0) { a4.style.height = 0; exp4.classList.toggle('is-active'); }
  if (a5.offsetHeight > 0) { a5.style.height = 0; exp5.classList.toggle('is-active'); }
  if (a6.offsetHeight > 0) { a6.style.height = 0; exp6.classList.toggle('is-active'); }
  if (a7.offsetHeight > 0) { a7.style.height = 0; exp7.classList.toggle('is-active'); }
});

// Question / Answer 2b
q2b.addEventListener('click', function () {
  //adjust the height of the answer
  if (a2b.offsetHeight == 0) {
    a2b.style.height = a2bText.offsetHeight + 20 + "px";
    logEvent(analytics, 'faq_one_designer_opened');
  }
  else {
    a2b.style.height = 0;
    logEvent(analytics, 'faq_one_designer_closed');
  }

  //toggle the expander UI
  exp2b.classList.toggle('is-active');

  //collapse any other expanded questions
  if (a1.offsetHeight > 0) { a1.style.height = 0; exp1.classList.toggle('is-active'); }
  if (a2.offsetHeight > 0) { a2.style.height = 0; exp2.classList.toggle('is-active'); }
  if (a3.offsetHeight > 0) { a3.style.height = 0; exp3.classList.toggle('is-active'); }
  if (a4.offsetHeight > 0) { a4.style.height = 0; exp4.classList.toggle('is-active'); }
  if (a5.offsetHeight > 0) { a5.style.height = 0; exp5.classList.toggle('is-active'); }
  if (a6.offsetHeight > 0) { a6.style.height = 0; exp6.classList.toggle('is-active'); }
  if (a7.offsetHeight > 0) { a7.style.height = 0; exp7.classList.toggle('is-active'); }
});

// Question / Answer 3
q3.addEventListener('click', function () {
  //adjust the height of the answer
  if (a3.offsetHeight == 0) {
    a3.style.height = a3Text.offsetHeight + 20 + "px";
    logEvent(analytics, 'faq_how_many_requests_opened');
  }
  else {
    a3.style.height = 0;
    logEvent(analytics, 'faq_how_many_requests_closed');
  }

  //toggle the expander UI
  exp3.classList.toggle('is-active');

  //collapse any other expanded questions
  if (a1.offsetHeight > 0) { a1.style.height = 0; exp1.classList.toggle('is-active'); }
  if (a2.offsetHeight > 0) { a2.style.height = 0; exp2.classList.toggle('is-active'); }
  if (a2b.offsetHeight > 0) { a2b.style.height = 0; exp2b.classList.toggle('is-active'); }
  if (a4.offsetHeight > 0) { a4.style.height = 0; exp4.classList.toggle('is-active'); }
  if (a5.offsetHeight > 0) { a5.style.height = 0; exp5.classList.toggle('is-active'); }
  if (a6.offsetHeight > 0) { a6.style.height = 0; exp6.classList.toggle('is-active'); }
  if (a7.offsetHeight > 0) { a7.style.height = 0; exp7.classList.toggle('is-active'); }
});

// Question / Answer 4
q4.addEventListener('click', function () {
  //adjust the height of the answer
  if (a4.offsetHeight == 0) {
    a4.style.height = a4Text.offsetHeight + 20 + "px";
    logEvent(analytics, 'faq_when_see_progress_opened');
  }
  else {
    a4.style.height = 0;
    logEvent(analytics, 'faq_when_see_progress_closed');
  }

  //toggle the expander UI
  exp4.classList.toggle('is-active');

  //collapse any other expanded questions
  if (a1.offsetHeight > 0) { a1.style.height = 0; exp1.classList.toggle('is-active'); }
  if (a2.offsetHeight > 0) { a2.style.height = 0; exp2.classList.toggle('is-active'); }
  if (a2b.offsetHeight > 0) { a2b.style.height = 0; exp2b.classList.toggle('is-active'); }
  if (a3.offsetHeight > 0) { a3.style.height = 0; exp3.classList.toggle('is-active'); }
  if (a5.offsetHeight > 0) { a5.style.height = 0; exp5.classList.toggle('is-active'); }
  if (a6.offsetHeight > 0) { a6.style.height = 0; exp6.classList.toggle('is-active'); }
  if (a7.offsetHeight > 0) { a7.style.height = 0; exp7.classList.toggle('is-active'); }
});

// Question / Answer 5
q5.addEventListener('click', function () {
  //adjust the height of the answer
  if (a5.offsetHeight == 0) {
    a5.style.height = a5Text.offsetHeight + 20 + "px";
    logEvent(analytics, 'faq_what_if_not_satisfied_opened');
  }
  else {
    a5.style.height = 0;
    logEvent(analytics, 'faq_what_if_not_satisfied_closed');
  }

  //toggle the expander UI
  exp5.classList.toggle('is-active');

  //collapse any other expanded questions
  if (a1.offsetHeight > 0) { a1.style.height = 0; exp1.classList.toggle('is-active'); }
  if (a2.offsetHeight > 0) { a2.style.height = 0; exp2.classList.toggle('is-active'); }
  if (a2b.offsetHeight > 0) { a2b.style.height = 0; exp2b.classList.toggle('is-active'); }
  if (a3.offsetHeight > 0) { a3.style.height = 0; exp3.classList.toggle('is-active'); }
  if (a4.offsetHeight > 0) { a4.style.height = 0; exp4.classList.toggle('is-active'); }
  if (a6.offsetHeight > 0) { a6.style.height = 0; exp6.classList.toggle('is-active'); }
  if (a7.offsetHeight > 0) { a7.style.height = 0; exp7.classList.toggle('is-active'); }
});

// Question / Answer 6
q6.addEventListener('click', function () {
  //adjust the height of the answer
  if (a6.offsetHeight == 0) {
    a6.style.height = a6Text.offsetHeight + 20 + "px";
    logEvent(analytics, 'faq_what_if_out_of_needs_opened');
  }
  else {
    a6.style.height = 0;
    logEvent(analytics, 'faq_what_if_out_of_needs_closed');
  }

  //toggle the expander UI
  exp6.classList.toggle('is-active');

  //collapse any other expanded questions
  if (a1.offsetHeight > 0) { a1.style.height = 0; exp1.classList.toggle('is-active'); }
  if (a2.offsetHeight > 0) { a2.style.height = 0; exp2.classList.toggle('is-active'); }
  if (a2b.offsetHeight > 0) { a2b.style.height = 0; exp2b.classList.toggle('is-active'); }
  if (a3.offsetHeight > 0) { a3.style.height = 0; exp3.classList.toggle('is-active'); }
  if (a4.offsetHeight > 0) { a4.style.height = 0; exp4.classList.toggle('is-active'); }
  if (a5.offsetHeight > 0) { a5.style.height = 0; exp5.classList.toggle('is-active'); }
  if (a7.offsetHeight > 0) { a7.style.height = 0; exp7.classList.toggle('is-active'); }
});

// Question / Answer 7
q7.addEventListener('click', function () {
  //adjust the height of the answer
  if (a7.offsetHeight == 0) {
    a7.style.height = a7Text.offsetHeight + 20 + "px";
    logEvent(analytics, 'faq_more_info_opened');
  }
  else {
    a7.style.height = 0;
    logEvent(analytics, 'faq_more_info_closed');
  }

  //toggle the expander UI
  exp7.classList.toggle('is-active');

  //collapse any other expanded questions
  if (a1.offsetHeight > 0) { a1.style.height = 0; exp1.classList.toggle('is-active'); }
  if (a2.offsetHeight > 0) { a2.style.height = 0; exp2.classList.toggle('is-active'); }
  if (a2b.offsetHeight > 0) { a2b.style.height = 0; exp2b.classList.toggle('is-active'); }
  if (a3.offsetHeight > 0) { a3.style.height = 0; exp3.classList.toggle('is-active'); }
  if (a4.offsetHeight > 0) { a4.style.height = 0; exp4.classList.toggle('is-active'); }
  if (a5.offsetHeight > 0) { a5.style.height = 0; exp5.classList.toggle('is-active'); }
  if (a6.offsetHeight > 0) { a6.style.height = 0; exp6.classList.toggle('is-active'); }
});

// Adjust the height of expanded answers on window resize
function adjustFAQanswerHeight() {
  if (a1.offsetHeight > 0) { a1.style.height = a1Text.offsetHeight + 20 + "px"; }
  if (a2.offsetHeight > 0) {  a2.style.height = a2Text.offsetHeight + 20 + "px"; }
  if (a2b.offsetHeight > 0) {  a2b.style.height = a2bText.offsetHeight + 20 + "px"; }
  if (a3.offsetHeight > 0) { a3.style.height = a3Text.offsetHeight + 20 + "px"; }
  if (a4.offsetHeight > 0) { a4.style.height = a4Text.offsetHeight + 20 + "px"; }
  if (a5.offsetHeight > 0) { a5.style.height = a5Text.offsetHeight + 20 + "px"; }
  if (a6.offsetHeight > 0) { a6.style.height = a6Text.offsetHeight + 20 + "px"; }
  if (a7.offsetHeight > 0) { a7.style.height = a7Text.offsetHeight + 20 + "px"; }
}

window.addEventListener('resize', adjustFAQanswerHeight);
